import { SupplierSubscriptionReleaseFlagsMessage } from '../../../supplier-subscription-plans/types/SupplierSubscriptionReleaseFlagsMessage';
import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

export const getSupplierSubscriptionReleaseFlags = async (): Promise<SupplierSubscriptionReleaseFlagsMessage> => {
    const response = await authorizedAxiosInstance.get<SupplierSubscriptionReleaseFlagsMessage>(
        '/v1/supplier-subscription-plans/release-flags'
    );
    return response.data;
};
